import { mapStateToAcronym, mapStateToFullName } from "@/helpers";
import { AddressType, BigCommerceAddress } from "@/types/CustomerInfo";


export const EmptyStandardAddress = {
  id: 0,
  firstName: '',
  lastName: '',
  company: '',
  street1: '',
  street2: '',
  stateAcronym: '' as '',
  state:'' as '',
  city: '',
  zip: '',
  phone: '',
}

export const EmptyBigCommerceAddress = {
  id: 0,
  address1: '',
  address2: '',
  address_type: '',
  city: '',
  company: '',
  country: '',
  country_code: '',
  customer_id: -1,
  first_name: '',
  last_name: '',
  phone: '',
  postal_code: '',
  state_or_province: '',
}

export const BigCommerceToStandardAddress: (addr?: BigCommerceAddress) => AddressType = ({
  address_type: addressType,
  country_code: countryCode,
  customer_id: customerId,
  first_name: firstName,
  last_name: lastName,
  state_or_province: state,
  address1: street1,
  address2: street2,
  postal_code: zip,
  ...rest
} = EmptyBigCommerceAddress) => ({
  addressType,
  countryCode,
  customerId,
  firstName,
  lastName,
  state: mapStateToFullName(state),
  stateAcronym: mapStateToAcronym(state),
  street1,
  street2,
  zip,
  ...rest,
})


export const StandardToBigCommerceAddress: (addr?: AddressType) => BigCommerceAddress = ({
  id,
  countryCode: country_code = 'US',
  firstName: first_name,
  lastName: last_name,
  state,
  stateAcronym,
  street1: address1,
  street2: address2 = '',
  zip: postal_code,
  addressType: address_type = 'residential',
  company = '',
  customerId: customer_id = 0,
  city,
  phone,
} = EmptyStandardAddress) => ({
  id,
  address_type,
  country_code,
  company,
  first_name,
  last_name,
  state_or_province: mapStateToFullName(state || stateAcronym),
  address1,
  address2,
  postal_code,
  city,
  phone,
  customer_id,
})